import { render, staticRenderFns } from "./NavVerticalSoporte.vue?vue&type=template&id=0f01190e&scoped=true"
import script from "./NavVerticalSoporte.vue?vue&type=script&lang=js"
export * from "./NavVerticalSoporte.vue?vue&type=script&lang=js"
import style0 from "./NavVerticalSoporte.vue?vue&type=style&index=0&id=0f01190e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f01190e",
  null
  
)

export default component.exports